import React from 'react';
import { SalesPage } from './pages/SalesPage';
export function App() {
  return <SalesPage data-id="element-0" data-mp="35cbxsgdarz8b" />;
}